
//SELECTORS
var productSlider = $('.product-slider');
var footerAccordian = $('.footer-right .header');
var mobileMenuAccordian = $('.site-nav--has-dropdown .site-nav__link--main');

$(document).ready(function(){
  // Product Image Slider (mobile only)
  productSlider.slick({
    prevArrow:"<button type='button' class='slick-prev pull-left'><img src='https://cdn.shopify.com/s/files/1/2401/4707/files/icon-angle-left.png?14202733474575813438'></button>",
    nextArrow:"<button type='button' class='slick-next pull-left'><img src='https://cdn.shopify.com/s/files/1/2401/4707/files/icon-angle-right.png?2907537522555585706'></button>"
  });

  footerAccordian.click(function(){
    $(this).siblings('li').slideToggle();
    $(this).find('i').toggleClass('spin-once');
  });

  mobileMenuAccordian.click(function(evt){
    evt.preventDefault();
    $(this).next('div').slideToggle();
    $(this).find('svg').toggleClass('spin-once');
  });

  //bind scroll to prevent helpcenter app from jumping on page load
  $(document).bind('scroll',function () {
    window.scrollTo(0,0);
  });

  setTimeout(function(){ $(document).unbind('scroll'); }, 600);


});
